import { render, staticRenderFns } from "./Preparations.vue?vue&type=template&id=6bb3d32d&scoped=true&"
import script from "./Preparations.vue?vue&type=script&lang=js&"
export * from "./Preparations.vue?vue&type=script&lang=js&"
import style0 from "./Preparations.vue?vue&type=style&index=0&id=6bb3d32d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb3d32d",
  null
  
)

export default component.exports